export default "__VITE_ASSET__85iIPgDm__"